import { Column, TableProps, useTable } from 'react-table';
import styles from './Table.module.css';

export function Table<T extends object>({
  columns,
  data,
}: {
  columns: Array<Column<T>>;
  data: T[];
} & TableProps) {
  // Use the state and functions returned from useTable to build your UI
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({
      columns,
      data,
    });

  // Render the UI for your table
  return (
    <table {...getTableProps()} className={styles['table-main']}>
      <thead className={styles['table-header']}>
        {headerGroups.map((headerGroup, groupIndex) => (
          <tr {...headerGroup.getHeaderGroupProps()} key={groupIndex}>
            {headerGroup.headers.map((column, headerIndex) => (
              <th
                {...column.getHeaderProps()}
                key={headerIndex}
                className={styles['header-cell']}
              >
                {column.render('Header')}
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()} className={styles['table-body']}>
        {rows.map((row, rowIndex) => {
          prepareRow(row);
          return (
            <tr {...row.getRowProps()} key={rowIndex}>
              {row.cells.map((cell, cellIndex) => {
                return (
                  <td
                    {...cell.getCellProps()}
                    key={cellIndex}
                    className={styles['table-cell']}
                  >
                    {cell.render('Cell')}
                  </td>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
